import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/workOrderRevenues${`?workOrderIds=${string}&dueDates=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/workOrderRevenues`;

/**
 *
 * @param dueDates YYYY-MM-DD
 */
export const URL = (workOrderIds: number[], dueDates: string[]): RouteDefinition =>
	`${baseRoute}/workOrderRevenues?workOrderIds=${encodeURIComponent((JSON.stringify(workOrderIds)))}&dueDates=${JSON.stringify(dueDates)}`;
